import Container from '@components/container';
import { ContainerSize, Image } from '@lib/types';
import NextImage from '@components/image';

type ImageSectionProps = {
  data: Image;
};

export default function ImageSection({ data: { image } }: ImageSectionProps) {
  return (
    <Container size={ContainerSize.wide}>
      <div className="lg:grid grid-cols-12 gap-1.5 md:gap-6">
        <div className="col-start-3 col-span-8">
          <NextImage
            className="w-full rounded-xl md:rounded-3xl"
            src={image}
            height={image.height}
            width={image.width}
            alt={image.alternativeText}
            sizes="100vw"
          />
        </div>
      </div>
    </Container>
  );
}
